import { ReactNode } from 'react';
import styled from 'styled-components';
import {
    space,
    layout,
    border,
    position,
    shadow,
    SpaceProps,
    LayoutProps,
    BorderProps,
    PositionProps,
    ShadowProps,
    BackgroundProps,
    background,
} from 'styled-system';
import { color, ColorProps } from '../utils/styled-components/styledSystem';

export type BoxProps = React.HTMLAttributes<HTMLDivElement> &
    SpaceProps &
    LayoutProps &
    BorderProps &
    PositionProps &
    ShadowProps &
    ColorProps &
    BackgroundProps & {
        children?: ReactNode | ReactNode[];
        cursor?: string;
    };

export const Box = styled.div<BoxProps>`
    box-sizing: border-box;
    ${space}
    ${layout}
    ${border}
    ${position}
    ${shadow}
    ${color}
    ${background}
    ${({ cursor }) => cursor && `cursor: ${cursor};`}
`;

Box.displayName = 'Box';
